var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentBlock"},[_c('sc-text',{staticClass:"display-4",attrs:{"tag":"h2","field":_vm.fields.heading}}),_c('sc-rich-text',{staticClass:"contentDescription",attrs:{"field":_vm.fields.content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }